module.exports = __webpack_public_path__ + "static/logo-9eae3b0497b6b4d1f2bd9cc513a9fb85.png";